import { defineMessages } from 'react-intl-next';

export default defineMessages({
	errorNotificationTitle: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.error-notification-title',
		defaultMessage: 'Failed to save Rovo Dev CLI configuration',
		description:
			'The title of the error message displayed when saving the rovo dev cli configuration is failed',
	},
	successNotificationTitle: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.success-notification-title',
		defaultMessage: 'Rovo Dev CLI has been enabled',
		description:
			'The title of the success message displayed when saving the rovo dev cli configuration is saved succesfully',
	},
	successNotificationDescription: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.success-notification-description',
		defaultMessage: 'All users on this site can now use this feature.',
		description:
			'The description of the success message displayed when saving the rovo dev cli configuration is saved succesfully',
	},
	dismissFlagAckButtonTitle: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.dismiss-flag-ack-button-title',
		defaultMessage: 'Got it',
		description:
			'The title of the acknowledge button on the dismiss flag displayed on the notification when the rovo dev cli configuration is saved successfully',
	},
	dismissFlagLearnMoreButtonTitle: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.dismiss-learn-more-button-title',
		defaultMessage: 'Learn more',
		description:
			'The title of the learn more button on the dismiss flag displayed on the notification when the rovo dev cli configuration is saved successfully',
	},
	breadCrumbTitle: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.bread-crumb-title',
		defaultMessage: 'Set up Rovo Dev CLI',
		description: 'The title of breadcrumb item for the rovo dev cli settings page',
	},
	pageDescription: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.page-description',
		defaultMessage:
			'Developers can code with Rovo Dev directly in their terminal, plus access to all your team’s Jira and Confluence knowledge without switching context.',
		description: 'The description of rovo dev cli displayed on the page.',
	},
	learnMoreLinkTitle: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.learn-more-link-title',
		defaultMessage: 'Read more about Rovo Dev CLI',
		description: 'The title of the link to learn more about rovo dev cli.',
	},
	limitReachedInfoHeading: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.limit-reached-info-heading',
		defaultMessage: "Rovo Dev in the CLI isn't open to new users right now",
		description:
			'The title of the information displayed on the page when CLI hits capacity and is not open for new users to use.',
	},
	limitReachedInfoMessage: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.limit-reached-info-message',
		defaultMessage:
			"We've reached the maximum number of users for Rovo Dev in the CLI. Join the waitlist and we'll automatically activate it for you once there's more capacity.",
		description:
			'The body of the information displayed on the page when CLI hits capacity and is not open for new users to use.',
	},
	jointWaitlistButtonTitle: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.join-waitlist-button-title',
		defaultMessage: 'Join the waitlist',
		description:
			'The title of the button that allows users join the waitlist when CLI hits capacity and is no longer open for new users to use',
	},
	enableToggleTitle: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-settings.enable-toggle-title',
		defaultMessage: 'Enable Rovo Dev CLI',
		description: 'The title of the toggle used to enable or disable the rovo dev cli',
	},
	heading: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-instructions.heading',
		defaultMessage: 'Rovo Dev is ready to use in the terminal',
		description: 'The heading of the instructions block displayed in the page to use rovo dev cli',
	},
	description: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-instructions.description',
		defaultMessage:
			'Rovo Dev CLI is an extension for <link>Atlassian Command Line Interface (ACLI)</link>.',
		description:
			'The description of CLI displayed in the instructions block explaining how Rovo Dev CLI is an extension for ACLI.',
	},
	stepOne: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-instructions.step-one',
		defaultMessage: 'To install Rovo Dev on your device',
		description: 'Step one of the instructions to use rovo dev cli',
	},
	stepTwo: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-instructions.step-two',
		defaultMessage:
			'Install ACLI (or update to the latest version if you already have ACLI installed) using instructions for your OS',
		description: 'Step two of the instructions to use rovo dev cli. Do not translate ACLI and OS',
	},
	stepThree: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-instructions.step-three',
		defaultMessage: 'Generate an API token from your <link>Atlassian profile</link>.',
		description:
			'Step three of the instructions to use rovo dev cli that API token can be generated from their atlassian profile.',
	},
	stepFour: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-instructions.step-four',
		defaultMessage: 'In your terminal, run',
		description:
			'Step four of the instructions to use rovo dev cli that explains how to run a command in terminal.',
	},
	stepFive: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-instructions.step-five',
		defaultMessage: 'Run this command to open Rovo Dev in interactive mode',
		description:
			'Step five of the instructions to use rovo dev cli that explains what command to run in terminal for interactive mode.',
	},
	copiedTooltip: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-instructions.copied-tooltip',
		defaultMessage: 'Copied',
		description:
			'The tooltip displayed when a command is copied using the clipboard copy button next to the commands.',
	},
	learnMoreToUseLinkTitle: {
		id: 'dev-agents.app.settings.rovo-dev-cli.rovo-dev-cli-instructions.learn-more-to-use-link-title',
		defaultMessage: 'Read more about how to use Rovo Dev CLI',
		description: 'The title of the link that has instructions on how to use rovo dev cli',
	},
});
